import { useReducer } from 'react';

// Actions
const TOGGLE_COMPONENT_LIBRARY = 'voyager/builder/TOGGLE_COMPONENT_LIBRARY';
const SECTION_START_DRAGGING = 'voyager/builder/SECTION_START_DRAGGING';
const SECTION_STOP_DRAGGING = 'voyager/builder/SECTION_STOP_DRAGGING';
const WIDGET_START_DRAGGING = 'voyager/builder/WIDGET_START_DRAGGING';
const WIDGET_STOP_DRAGGING = 'voyager/builder/WIDGET_STOP_DRAGGING';
const SECTION_EDIT_START = 'voyager/builder/SECTION_EDIT_START';
const SECTION_EDIT_STOP = 'voyager/builder/SECTION_EDIT_STOP';
const WIDGET_EDIT_START = 'voyager/builder/WIDGET_EDIT_START';
const WIDGET_EDIT_STOP = 'voyager/builder/WIDGET_EDIT_STOP';
const WIDGET_START_SWITCHING = 'voyager/builder/WIDGET_START_SWITCHING';
const WIDGET_STOP_SWITCHING = 'voyager/builder/WIDGET_STOP_SWITCHING';

// Reducer
const initialState = {
  showComponentLibrary: false,
  sectionIsDragging: false,
  widgetIsDragging: false,
  componentIsDragging: false,
  isEditingPage: true,
  editingSections: {},
  editingWidgets: {},
  widgetSwitchingId: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case TOGGLE_COMPONENT_LIBRARY:
      return {
        ...state,
        showComponentLibrary: !state.showComponentLibrary,
        widgetSwitchingId: null,
      };
    case SECTION_START_DRAGGING:
      return {
        ...state,
        sectionIsDragging: true,
        showComponentLibrary: false,
      };
    case SECTION_STOP_DRAGGING:
      return { ...state, sectionIsDragging: false };
    case WIDGET_START_DRAGGING:
      return {
        ...state,
        widgetIsDragging: true,
        showComponentLibrary: false,
      };
    case WIDGET_STOP_DRAGGING:
      return { ...state, widgetIsDragging: false };
    case SECTION_EDIT_START:
      return {
        ...state,
        editingSections: {
          ...state.editingSections,
          [action.id]: action.value,
        },
      };
    case SECTION_EDIT_STOP:
      return {
        ...state,
        editingSections: {
          ...state.editingSections,
          [action.id]: false,
        },
      };
    case WIDGET_EDIT_START:
      return {
        ...state,
        editingWidgets: {
          ...state.editingWidgets,
          [action.id]: action.value,
        },
      };
    case WIDGET_EDIT_STOP:
      return {
        ...state,
        editingWidgets: {
          ...state.editingWidgets,
          [action.id]: false,
        },
      };

    case WIDGET_START_SWITCHING: {
      return {
        ...state,
        widgetSwitchingId: action.id,
      };
    }
    case WIDGET_STOP_SWITCHING: {
      return {
        ...state,
        widgetSwitchingId: null,
      };
    }

    default:
      return state;
  }
};

const useLayoutEditor = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const onToggleComponentLibrary = () => {
    dispatch({
      type: TOGGLE_COMPONENT_LIBRARY,
    });
  };

  const onSectionStartDragging = () => {
    dispatch({
      type: SECTION_START_DRAGGING,
    });
  };

  const onSectionStopDragging = () => {
    dispatch({
      type: SECTION_STOP_DRAGGING,
    });
  };

  const onWidgetStartDragging = () => {
    dispatch({
      type: WIDGET_START_DRAGGING,
    });
  };

  const onWidgetStopDragging = () => {
    dispatch({
      type: WIDGET_STOP_DRAGGING,
    });
  };

  const onWidgetStartSwitching = (id) => {
    dispatch({
      type: WIDGET_START_SWITCHING,
      id,
    });
  };

  const onWidgetStopSwitching = () => {
    dispatch({
      type: WIDGET_STOP_SWITCHING,
    });
  };

  const onSectionEditStart = (id, value = true) => {
    dispatch({
      type: SECTION_EDIT_START,
      id,
      value,
    });
  };

  const onSectionEditStop = (id) => {
    dispatch({
      type: SECTION_EDIT_STOP,
      id,
    });
  };

  const onWidgetEditStart = (id, value = true) => {
    dispatch({
      type: WIDGET_EDIT_START,
      id,
      value,
    });
  };

  const onWidgetEditStop = (id) => {
    dispatch({
      type: WIDGET_EDIT_STOP,
      id,
    });
  };

  const getWidgetSwitchingId = () => state.id;

  return [
    state,
    {
      onToggleComponentLibrary,
      onSectionStartDragging,
      onSectionStopDragging,
      onWidgetStartDragging,
      onWidgetStopDragging,
      onWidgetStartSwitching,
      onWidgetStopSwitching,
      onSectionEditStart,
      onSectionEditStop,
      onWidgetEditStart,
      onWidgetEditStop,
      getWidgetSwitchingId,
    },
  ];
};

export default useLayoutEditor;
